import { ComboBoxItem } from '../types/comboBoxItem'

export const getItemById = (items: ComboBoxItem[], itemId: string): ComboBoxItem | undefined => {
  if (!items.length || !itemId) {
    return undefined
  }

  return items.find((item) => item.id === itemId)
}
